<template>
  <div class="df-recebidos">
    <template v-if='statusGeral !== ""'>
      <RF-Status :cpntStatus='statusGeral' :cpntTamanho='5'></RF-Status>
    </template>

    <template v-else-if='statusGeral === ""'>
      <div class="cabecalho">
        <App-Filtros
        :cpntMontarCampoF="dfRecebidosOnBuscarOptionsFiltroF"
        :cpntMontarCampoO="dfRecebidosOnBuscarOptionsFiltroO"
        :cpntMontarCampoV="dfRecebidosOnBuscarOptionsFiltroV"
        :cpntFiltroPredefinido="{ f: 'nome', o: '%', v: '' }"

        :cpntInputCoringa="{}"
        :cpntApiTabPer="tabper"
        @BUSCAR='dfRecebidosBuscarLinhas'
        ref="filtros"></App-Filtros>
      </div>

      <!-- SETA A TABELA -->
      <div class="tabela">
        <App-Tabela
        :cpntSetarFiltros="dfRecebidosSetarFiltros"
        :cpntMontarFiltros="dfRecebidosMontarFiltros"
        :cpntMontarWhere="dfRecebidosTabelaMontarWhere"
        :cpntCheckbox="checkbox"
        :cpntColuna="colunas"
        :cpntLinha="linha"
        :cpntMostrarMper="true"
        :cpntSetarValores="dfRecebidosSetarLinhas"
        :cpntApiTabPer="tabper"
        :cpntApiTabPerOrder="tabPerOrder"
        :cpntApiRouter="route"
        :cpntApiWhere="where"
        :cpntApiMethods="'POST'"
        :cpntApiEstruturaQueryGet="estruturaQueryGet"
        @TABELA_MARCAR_CHECKBOX='dfRecebidosMarcarCheckbox'
        ref="tabela">
          <template slot="botoes">
            <RF-Button :data-time="time" 
              :cpntId='campos.sincronizar.id'
              :cpntStatus='campos.sincronizar.status' 
              :cpntIcone='campos.sincronizar.icone'
              :cpntTexto='campos.sincronizar.texto'
              :cpntClass='campos.sincronizar.class'
              :cpntMostrar='campos.sincronizar.mostrar'
              :cpntDisabled="campos.sincronizar.disabled"
              :cpntExplica="campos.sincronizar.explica"
              @onClickButton='campos.sincronizar.onClick'
            ></RF-Button>
          </template>

          <template v-slot:col_emissor="{ linha }">
            <!-- SETA O NOME DO EMITENTE -->
            <div v-if="[ '', null, undefined ].indexOf(linha.xNome) === -1">
              <span class="valor" v-html="linha.xNome"></span>
            </div>

            <!-- SETA O CNPJ DO EMITENTE -->
            <div v-if="[ '', null, undefined ].indexOf(linha.CNPJ) === -1">
              <!-- SETA O TITULO -->
              <span class="titulo">CNPJ: </span>

              <!-- SETA O VALOR -->
              <span class="valor" v-html="linha.CNPJ"></span>
            </div>

            <!-- SETA O IE DO EMITENTE -->
            <div v-if="[ '', null, undefined ].indexOf(linha.IE) === -1">
              <!-- SETA O TITULO -->
              <span class="titulo">IE: </span>

              <!-- SETA O VALOR -->
              <span class="valor" v-html="linha.IE"></span>
            </div>
          </template>

          <template v-slot:col_operacao="{ linha }">
            <template v-if="[ '0', '1' ].indexOf(linha.tpNF) === -1">
              ---
            </template>
            <template v-else>
              {{ linha.tpNF }} - {{ linha.tpNF === '0' ? 'Entrada' : 'Saída' }}
            </template>
          </template>

          <template v-slot:col_valor="{ linha }">
            <span v-html="'R$ ' + linha.vNF"></span>
          </template>

          <template v-slot:col_DocDhAut_ptbra="{ linha }">
            <span v-html="linha.DocDhAut_ptbr"></span>
          </template>

          <template v-slot:col_compra="{ linha }">
            <div v-if="linha.schemaAbrev !== 'procNFe'">
              ---
            </div>
            <template v-else>
              <RF-Button v-if="[ '', null, undefined ].indexOf(linha.cod_op) !== -1 && [ '', null, undefined ].indexOf(linha.jStatusCancelamento) !== -1"
                :cpntId='campos.compra.id'
                :cpntStatus='campos.compra.status' 
                :cpntTipo='campos.compra.tipo'
                :cpntTexto='campos.compra.texto'
                :cpntIcone='campos.compra.icone'
                :cpntDisabled="[ '', null, undefined ].indexOf(linha.jStatusCancelamento) === -1"
                :cpntClass='campos.compra.class'
                @onClickButton='() => { campos.compra.onClick(linha.id) }'
              ></RF-Button>

              <RF-Button v-else-if="[ '', null, undefined ].indexOf(linha.cod_op) === -1"
                :cpntId='campos.compra.id'
                :cpntStatus='campos.compra.status' 
                :cpntTipo='campos.compra.tipo'
                :cpntTexto='"C " + dfRecebidosFormatarNumeroCompra(linha.cod_op)'
                :cpntIcone='campos.compra.icone'
                :cpntDisabled="[ '', null, undefined ].indexOf(linha.jStatusCancelamento) === -1"
                :cpntClass='[ "btn", "btn-sm", "btn-primary" ]'
                @onClickButton='() => { dfRecebidosAbrirCompra(linha.cod_op) }'
              ></RF-Button>

              <span v-else>---</span>
            </template>
          </template>

          <template v-slot:col_status="{ linha }">
            <div v-if="[ '', null, undefined ].indexOf(linha.xml) === -1" style="padding: 15px 0px;">
              ---
            </div>
            <template v-else>
              <div class="botao cinza" v-if="[ '', null, undefined ].indexOf(linha.jStatusCancelamento) === -1">
                <table>
                  <tr>
                    <td>
                      <App-Icones :cpntIcone="'cancelar'"></App-Icones>
                    </td>
                    <td style="text-align: left;">
                      <span v-html="'Nota cancelada em :' + linha.jStatusCancelamento.dhEvento_ptbr"></span>
                      <br/>
                      <span v-html="'Motivo: ' + linha.jStatusCancelamento.xJust"></span>
                    </td>
                  </tr>
                </table>
              </div>

              <div class="botao verde" v-else-if="([ '', null, undefined ].indexOf(linha.jStatusCienciaOperacao) === -1 && [ '999', 999 ].indexOf(linha.jStatusCienciaOperacao.cStat) === -1) || [ 'procNFe' ].indexOf(linha.schemaAbrev) !== -1">
                <table>
                  <tr>
                    <td>
                      <App-Icones :cpntIcone="'fas fa-check'"></App-Icones>
                    </td>
                    <td style="text-align: left;">
                      <span v-html="'Ciência da operação realizada'"></span>
                      <span v-if="[ '', null, undefined ].indexOf(linha.jStatusCienciaOperacao) === -1" v-html="' em:<br/>' + linha.jStatusCienciaOperacao.dhRegEvento_ptbr">
                      </span>
                    </td>
                  </tr>
                </table>
              </div>

              <RF-Button class="botao btn-warning" v-else
                :cpntId='campos.ciencia.id'
                :cpntStatus='campos.ciencia.status'
                :cpntClass='campos.ciencia.class'
                @onClickButton='() => { campos.ciencia.onClick(linha) }'>
              <template slot="conteudo">
                <table>
                  <tr>
                    <td>
                      <App-Icones :cpntIcone="'cancelar'"></App-Icones>
                    </td>
                    <td style="text-align: left;">
                      <span v-html="'Ciência <b>NÃO</b> realizada.<br/>Clique aqui para realizar agora'"></span>
                    </td>
                  </tr>
                </table>
              </template>
              </RF-Button>
            </template>
          </template>

          <!-- AÇÃO CONTATO -->
          <template v-slot:col_acoes="{ linha }">
            <div v-if="linha.schemaAbrev !== 'procNFe'">
              ---
            </div>
            <div v-else>
              <RF-Button
                :cpntId='campos.danfe.id'
                :cpntStatus='campos.danfe.status' 
                :cpntTipo='campos.danfe.tipo'
                :cpntTexto='campos.danfe.texto'
                :cpntTitle='campos.danfe.texto'
                :cpntIcone='campos.danfe.icone'
                :cpntClass='campos.danfe.class'
                @onClickButton='() => { campos.danfe.onClick(linha.id) }'
              ></RF-Button>

              <RF-Button
                :cpntId='campos.xml.id'
                :cpntStatus='campos.xml.status' 
                :cpntTipo='campos.xml.tipo'
                :cpntTexto='campos.xml.texto'
                :cpntTitle='campos.xml.texto'
                :cpntIcone='campos.xml.icone'
                :cpntClass='campos.xml.class'
                @onClickButton='() => { campos.xml.onClick(linha.id) }'
              ></RF-Button>

              <RF-Button v-if="[ '', null, undefined ].indexOf(linha.jStatusCartaCorrecao) === -1"
                :cpntId='campos.cce.id'
                :cpntStatus='campos.cce.status' 
                :cpntTipo='campos.cce.tipo'
                :cpntTexto='campos.cce.texto'
                :cpntTitle='campos.cce.texto'
                :cpntIcone='campos.cce.icone'
                :cpntClass='campos.cce.class'
                @onClickButton='() => { campos.cce.onClick(linha.jStatusCartaCorrecao.idDist) }'
              ></RF-Button>
            </div>
          </template>
        </App-Tabela>
      </div>
    </template>

    <!-- LOCAL AONDE SERÁ ABERTO O FORMULARIO -->
    <router-view :cpntFecharFormulario="dfRecebidosFecharFormulario"></router-view>

    <!-- SETA A TELA PARA REALIZAR A CIENCIA DA OPERAÇÃO -->
    <App-Doc-Fiscais-Recebidos-Ciencia :data-time="time" v-if="[ '', null, undefined ].indexOf(dialog) === -1" :cpntDados="dialog" :cpntFecharFormulario="dfRecebidosFecharFormulario"></App-Doc-Fiscais-Recebidos-Ciencia>
  </div>
</template>

<style scoped>
</style>

<style>
  .df-recebidos > .tabela > table > thead > tr > td > .sincronizar {
    width: 80px;
  }
    .df-recebidos > .tabela > table > thead > tr > td > .sincronizar > div {
      display: inline-block;
      margin-left: 5px;
    }

  .df-recebidos > .tabela > table > tbody > tr.background-tp-5 > td {
    opacity: 0.65;
  }
  .df-recebidos > .tabela > table > tbody > tr > td.col_status {
    width: 290px;
  }
    .df-recebidos > .tabela > table > tbody > tr > td.col_status > div > span > .botao {
      padding: 5px 10px;
      font-size: 12px;
      line-height: 1.5;
      border-radius: 3px;
      opacity: 0.85;
    }
    .df-recebidos > .tabela > table > tbody > tr > td.col_status > div > span > .botao.verde {
      color: #fff;
      background-color: #5cb85c;
      border-color: #4cae4c;
    }
    .df-recebidos > .tabela > table > tbody > tr > td.col_status > div > span > .botao.cinza {
      color: #333;
      background-color: #fff;
      border-color: #ccc;
    }
    .df-recebidos > .tabela > table > tbody > tr > td.col_status > div > span > .botao {
      width: 100%;
      margin: 3px;
      padding: 0px;
      min-height: 38px;
    }
      .df-recebidos > .tabela > table > tbody > tr > td.col_status > div > span > .botao > div {
        display: none;
      }
      .df-recebidos > .tabela > table > tbody > tr > td.col_status > div > span > .botao > table {
        width: 100%;
        min-height: 38px;
      }
        .df-recebidos > .tabela > table > tbody > tr > td.col_status > div > span > .botao > table > tr > td {
          padding: 3px 5px;
        }
        .df-recebidos > .tabela > table > tbody > tr > td.col_status > div > span > .botao > table > tr > td:first-child {
          width: 30px;
        }
          .df-recebidos > .tabela > table > tbody > tr > td.col_status > div > span > .botao > table > tr > td:first-child > span > svg {
            font-size: 16px;
          }
        .df-recebidos > .tabela > table > tbody > tr > td.col_status > div > span > .botao > table > tr > td:last-child {
          width: calc(100% - 30px);
        }

  .df-recebidos > .tabela > table > tbody > tr > td.col_acoes {
    opacity: 1;
    max-width: 230px;
    text-align: center;
  }
    .df-recebidos > .tabela > table > tbody > tr > td.col_acoes > div > span > div > button {
      margin: 2px;
      padding: 5px;
      width: 40px;
      font-size: calc(100% - 1px);
      /* font-weight: bold; */
    }
    .df-recebidos > .tabela > table > tbody > tr > td.col_acoes > div > span > div > button > span > svg {
      font-size: 17px;
    }
    .df-recebidos > .tabela > table > tbody > tr > td.col_acoes > div > span > div > button > span > img {
      width: 17px;
    }
    /* .df-recebidos > .tabela > table > tbody > tr > td.col_acoes > div > span > div:first-child > button {
      width: calc(50% - 4px);
    }
    .df-recebidos > .tabela > table > tbody > tr > td.col_acoes > div > span > div.cce > button {
      width: calc(100% - 4px);
    } */

    .df-recebidos > .tabela > table > tbody > tr > td.col_compra {
      width: 100px;
      padding: 0px 5px;
    }
      .df-recebidos > .tabela > table > tbody > tr > td.col_compra > div > span > button {
        width: 100%;
      }
</style>

<script>
  // IMPORTA BIBLIOTECA DEPENDENTE
  var moment = require('moment')

  export default {
    components: {
      'App-Filtros': () => import('@/components/_geral/Filtros.vue'),
      'App-Icones': () => import('@/components/rf-geral/icones/RF-Icones.vue'),

      'App-Doc-Fiscais-Recebidos-Ciencia': () => import('@/components/df/recebidos/Doc-Fiscais-Recebidos-Ciencia.vue'),
    },
    data: function () {
      return {
        time: '',
        statusGeral: 'carregando',
        checkbox: [],
        tabper: 'DfDistribuicao',
        route: '/df/distribuicao/get',
        dialog: null,
        
        colunas: [],
        linha: [],
        tabPerOrder: [
          { id: '0', nome: 'Data Emissão Decrescente',      chave: 'DocDhAut',    order: 'desc' },
          { id: '1', nome: 'Data Emissão Crescente',        chave: 'DocDhAut',    order: 'asc' },
          { id: '2', nome: 'Ordem Alfabética Emissor',      chave: 'xNome',       order: 'asc' }
        ],  
        where: { aAnd: [ { f: 'schemaAbrev', o: '<>', v: 'procEventoNFe' }, { f: 'schemaAbrev', o: '<>', v: 'resEventoNFe' }, { f: 'schemaAbrev', o: '<>', v: 'resEvento' } ] },
        estruturaQueryGet: [ [ 'type', 'countAll', 'limit', 'field', 'where', 'order' ] ],
        campos: {
          danfe: {
            status: '',
            tipo: 'texto',
            texto: 'NF-e',
            icone: { tipo: 'danfe' },
            class: [ 'btn', 'btn-default', 'btn-sm', 'danfe' ],
            mostrar: true,
            onClick: (id) => { this.dfRecebidosAbrirDocumento(id, 'abrir') }
          },
          xml: {
            status: '',
            tipo: 'texto',
            texto: 'XML',
            icone: { tipo: 'xml' },
            class: [ 'btn', 'btn-default', 'btn-sm', 'xml' ],
            mostrar: true,
            onClick: (id) => { this.dfRecebidosAbrirDocumento(id, 'xml') }
          },
          cce: {
            status: '',
            tipo: 'texto',
            texto: 'CC-e',
            icone: { tipo: 'cce' },
            class: [ 'btn', 'btn-default', 'btn-sm', 'cce' ],
            mostrar: true,
            onClick: (id) => { this.dfRecebidosAbrirDocumento(id, 'abrir') }
          },
          ciencia: {
            status: '',
            tipo: 'texto',
            texto: 'XML',
            class: [ 'btn', 'btn-sm' ],
            mostrar: true,
            onClick: (linha) => { this.dfRecebidosDialogCiencia(linha) }
          },
          compra: {
            status: '',
            tipo: 'texto',
            texto: 'Gerar',
            class: [ 'btn', 'btn-sm', 'btn-info' ],
            mostrar: true,
            onClick: (id) => { this.dfRecebidosGerarCompra(id) }
          },
          sincronizar: {
            status: '',
            tipo: 'icone-texto',
            icone: 'fas fa-sync-alt',
            texto: 'Sefaz',
            class: [ 'btn', 'btn-primary', 'sincronizar' ],
            explica: { mensagem: 'Sincronizar com a Sefaz agora.<br/><br/>O Rotina Fácil consulta a Sefaz automaticamente todos os dias nos seguintes horários: 07:00, 12:00 e 16:00.<br/><br/>Evite fazer muitas consultas a Sefaz para que seu CNPJ não seja bloqueado.' },
            mostrar: true,
            onClick: this.dfRecebidosSincronizarNotas
          },
        }
      }
    },
    mounted: function () {
      // SETA O STATUS DA PAGINA
      this.dfRecebidosSetarStatusGeral('carregando')
      
      // INICIA O CARREGAMENTO DA TELA
      this.dfRecebidosBuscarLinhas()
    },
    destroyed: function () {
      $('.qtip-cpnt-tab-df-recebidos').qtip('destroy')
    },
    methods: {
      dfRecebidosFecharFormulario: function (atualizar) {
        // FECHA A DIALOG
        this.dfRecebidosDialogCiencia(null)

        // VERIFICA SE TEM QUE ATUALIZAR A TABELA
        if (atualizar === true) {
          this.dfRecebidosBuscarLinhas()
        }
      },
      dfRecebidosBuscarLinhas: function () {
        // SETA AS COLUNAS DA TABELA
        var colunas = [
          // { mPer: 3,    chave: 'id',                                                 tipo: 'checkbox' },
          { mPer: 0,    chave: 'id',              nome: 'Cód.'                                        },
          { mPer: 2,    chave: 'emissor',         nome: 'Emitente'                                    },
          { mPer: 1,    chave: 'operacao',        nome: 'Operação'                                    },
          { mPer: 0,    chave: 'chNFe',           nome: 'Chave de acesso'                             },
          { mPer: 0,    chave: 'nProt',           nome: 'Protocolo'                                   },
          { mPer: 2,    chave: 'nNF',             nome: 'Número'                                      },
          { mPer: 2,    chave: 'serie',           nome: 'Série'                                       },
          { mPer: 1,    chave: 'valor',           nome: 'Valor'                                       },
          { mPer: 1,    chave: 'DocDhAut_ptbr',   nome: 'Data/Hora Emissão'                           },
          { mPer: 1,    chave: 'status',          nome: 'Status'                                      },
          { mPer: 3,    chave: 'acoes',           nome: 'Ações'                                       },
          { mPer: 3,    chave: 'compra',          nome: 'Compra'                                      }
        ]

        // INCIA A VARIAVEL PARA REMOVER COLUNA
        var remover = []

        // REMOVE A COLUNA COMPRA
        if (this.$store.state.FUN_CHECK_AUTORIZACAO_USUARIO(false, [ 5 ], null, [ 11 ], null, [ 19 ], null, false) === false) {
          remover.push('compra')
        }

        // REMOVE AS COLUNAS INFORMADAS
        if (remover.length >= 1) {
          colunas = colunas.filter(item => remover.indexOf(item.chave) === -1)
        }

        // SETA AS COLUNAS MONTADAS
        this.colunas = colunas

        // VERIFICA SE TEM QUE BUSCAR E ATUALIZAR A TABELA       
        if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1 || this.statusGeral === '') {
          this.dfRecebidosReiniciar()
        } else {
          this.dfRecebidosSetarStatusGeral('')
        }
      },
      dfRecebidosTabelaMontarWhere: function (where) {
        // INICIA A VARIAVEL DE RETORNO
        var retorno = {}

        // CONVERTE O VALOR RECEBIDO
        if (where.o === '%') {
          where.o = 'like'
        }

        // VERIFICA SE DEVE SETAR ALGUM VALOR
        switch (where.f) {
          case 'nome':
            retorno.where = { f: 'xNome', o: where.o, v: where.v }
            break

          case 'cnpj':
            retorno.where = { f: 'CNPJ', o: where.o, v: where.v.replace(/([^\d])+/gim, '') }
            break

          case 'ie':
            retorno.where = { f: 'IE', o: where.o, v: where.v.replace(/([^\d])+/gim, '') }
            break

          case 'numero':
            retorno.where = { f: 'nNF', o: where.o, v: where.v }
            break

          case 'operacao':
            if (where.v === '1') {
              retorno.where = { f: 'tpNF', o: '=', v: '1' }
            } else {
              retorno.where = { f: 'tpNF', o: '<>', v: '1' }
            }
            break

          case 'status':
            if (where.v === '0') {
              retorno.where = { aAnd: [
                { f: 'schemaAbrev', o: '=', v: 'resNFe' },
                { f: 'jStatusCancelamento', o: 'isNull' }
              ] }
            } else if (where.v === '1') {
              retorno.where = { aAnd: [
                { f: 'schemaAbrev', o: '=', v: 'procNFe' },
                { f: 'jStatusCancelamento', o: 'isNull' }
              ] }
            } else if (where.v === '2') {
              retorno.where = { f: 'jStatusCancelamento', o: 'isNotNull' }
            }
            break
            
          case 'busca':
            retorno.where = { o: 's.ft', v: where.v }
            break

        }

        // RETORNA O VALOR MONTADO
        return retorno
      },
      dfRecebidosSetarStatusGeral: function (status) {
        // SETA O STATUS DA TELA
        this.statusGeral = status

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      dfRecebidosReiniciar: function (tentativa = 0) {
        if (tentativa <= 5) {
          if ([ '', null, undefined ].indexOf(this.$refs.tabela) === -1 && [ '', null, undefined ].indexOf(this.$refs.tabela.cpntTabelaReiniciar) === -1) {
            this.$refs.tabela.cpntTabelaReiniciar()
          } else {
            setTimeout(() => { this.dfRecebidosReiniciar((tentativa + 1)) }, 100)
          }
        }
      },
      dfRecebidosSetarFiltros: function (callback, filtros, tentativa = 0) {
        if (tentativa <= 5) {
          if ([ '', null, undefined ].indexOf(this.$refs.filtros) === -1 && [ '', null, undefined ].indexOf(this.$refs.filtros.cpntFiltroSetarFiltros) === -1) {
            this.$refs.filtros.cpntFiltroSetarFiltros(callback, filtros)
          } else {
            setTimeout(() => { this.dfRecebidosSetarFiltros(callback, filtros, (tentativa + 1)) }, 100)
          }
        }
      },
      dfRecebidosMontarFiltros: function (callback, tentativa = 0) {
        if (tentativa <= 5) {
          if ([ '', null, undefined ].indexOf(this.$refs.filtros) === -1 && [ '', null, undefined ].indexOf(this.$refs.filtros.cpntFiltrosMontar) === -1) {
            this.$refs.filtros.cpntFiltrosMontar(callback)
          } else {
            setTimeout(() => { this.dfRecebidosMontarFiltros(callback, (tentativa + 1)) }, 100)
          }
        }
      },
      dfRecebidosSetarLinhas: function (vetor) {
        // FORMATA TODOS OS CAMPOS RECEBIDOS
        for (var indexL in vetor) {
          // CONVERTE A DATA DA EMISSÃO
          vetor[indexL].DocDhAut_ptbr = moment(vetor[indexL].DocDhAut, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss')
          vetor[indexL].DocDhAut_ptbr = vetor[indexL].DocDhAut_ptbr.replace(' ', ' às ')

          // FORMATA O CNPJ
          vetor[indexL].CNPJ = vetor[indexL].CNPJ.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5')

          // FORMATA CHAVE DE ACESSO
          vetor[indexL].chNFe = vetor[indexL].chNFe.replace(/^(\d{4})(\d{4})(\d{4})(\d{4})(\d{4})(\d{4})(\d{4})(\d{4})(\d{4})(\d{4})(\d{4})/, '$1 $2 $3 $4 $5 $6 $7 $8 $9 $10 $11')

          // FORMATA O VALOR RECEBIDO
          vetor[indexL].vNF = this.$store.state.FUN_MASK_VALOR('valorDecimal', vetor[indexL].vNF)

          // VERIFICA SE TEM QUE CONVERTEREM JSON
          if ([ '', null, undefined ].indexOf(vetor[indexL].jStatusCartaCorrecao) === -1 && typeof vetor[indexL].jStatusCartaCorrecao === 'string') {
            vetor[indexL].jStatusCartaCorrecao = JSON.parse(vetor[indexL].jStatusCartaCorrecao)
          }

          // FAZ JSON PARSE NOS CAMPOS NECESSARIOS
          if ([ '', null, undefined ].indexOf(vetor[indexL].jStatusCancelamento) === -1) {
            // VERIFICA SE TEM QUE CONVERTEREM JSON
            if (typeof vetor[indexL].jStatusCancelamento === 'string') {
              vetor[indexL].jStatusCancelamento = JSON.parse(vetor[indexL].jStatusCancelamento)
            }

            // CONVERTE DA DATA E HORA
            vetor[indexL].jStatusCancelamento.dhEvento_ptbr = vetor[indexL].jStatusCancelamento.dhEvento
            vetor[indexL].jStatusCancelamento.dhEvento_ptbr = vetor[indexL].jStatusCancelamento.dhEvento_ptbr.replace('T', ' ')

            // CONVERTE A DATA DA EMISSÃO
            vetor[indexL].jStatusCancelamento.dhEvento_ptbr = moment(vetor[indexL].jStatusCancelamento.dhEvento, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss')
            vetor[indexL].jStatusCancelamento.dhEvento_ptbr = vetor[indexL].jStatusCancelamento.dhEvento_ptbr.replace(' ', ' às ')
            
            // SETA A COR DE FUNDO DA LINHA
            // vetor[indexL]._fundoF = 'background-tp-5'
            vetor[indexL]._fundoN = 'background-tp-5'
          }
          if ([ '', null, undefined ].indexOf(vetor[indexL].jStatusCienciaOperacao) === -1) {
            // VERIFICA SE TEM QUE CONVERTEREM JSON
            if (typeof vetor[indexL].jStatusCienciaOperacao === 'string') {
              vetor[indexL].jStatusCienciaOperacao = JSON.parse(vetor[indexL].jStatusCienciaOperacao)
            }

            // CONVERTE DA DATA E HORA
            vetor[indexL].jStatusCienciaOperacao.dhRegEvento_ptbr = vetor[indexL].jStatusCienciaOperacao.dhRegEvento
            vetor[indexL].jStatusCienciaOperacao.dhRegEvento_ptbr = vetor[indexL].jStatusCienciaOperacao.dhRegEvento_ptbr.replace('T', ' ')

            // CONVERTE A DATA DA EMISSÃO
            vetor[indexL].jStatusCienciaOperacao.dhRegEvento_ptbr = moment(vetor[indexL].jStatusCienciaOperacao.dhRegEvento, 'YYYY-MM-DD HH:mm:ss').format('DD/MM/YYYY HH:mm:ss')
            vetor[indexL].jStatusCienciaOperacao.dhRegEvento_ptbr = vetor[indexL].jStatusCienciaOperacao.dhRegEvento_ptbr.replace(' ', ' às ')
          }
        }
        
        // SETA OS VALORES RECEBIDOS
        this.linha = vetor

        // SETA O STATUS DO CAMPO
        this.campos.sincronizar.status = ''

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      dfRecebidosMarcarCheckbox: function (checked, value) {
        // VERIFICA A AÇÃO QUE DEVE REALIZAR COM OS CHECKBOXS
        switch (checked) {
          case true:
            this.checkbox.push(value)
            break

          case false:
            this.checkbox = this.checkbox.filter(item => item !== value)
            break
        }

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      },
      dfRecebidosOnBuscarOptionsFiltroF: function (callback) {
        // INICIA O VETOR PARA OS CAMPOS
        var vetor = {}

        // INICIA A VARIAVEL PARA ADICONAR A DEMANDA
        vetor.options = [
          { id: 'nome',             nome: 'Nome' },
          { id: 'cnpj',             nome: 'CNPJ' },
          { id: 'ie',               nome: 'Inscrição Estadual' },
          { id: 'operacao',         nome: 'Operação' },
          { id: 'numero',           nome: 'Número' },
          { id: 'status',           nome: 'Status' }
        ]

        // RETORNA O VALOR MONTADO
        callback(vetor)
      },
      dfRecebidosOnBuscarOptionsFiltroO: function (callback, valor) {
        // INICIA O VETOR PARA OS CAMPOS
        var vetor = { tipo: 'select', disabled: false }

        // VERIFICA OS OPTIONS QUE DEVE COLOCAR
        switch (valor.f) {
          case 'nome':
            // SETA O OPTION DO SELETOR
            vetor.options = [
              { id: '%',    nome: '% Contém', _formatar: [ 'id' ] },
              { id: '=',    nome: '= Igual', _formatar: [ 'id' ] }
            ]

            break

          case 'cnpj':
            // SETA O OPTION DO SELETOR
            vetor.options = [
              { id: '=',    nome: '= Igual', _formatar: [ 'id' ] },
              { id: '<>',    nome: '= Diferente', _formatar: [ 'id' ] }
            ]

            break

          case 'operacao':
          case 'status':
          case 'numero':
            // SETA O OPTION DO SELETOR
            vetor.options = [
              { id: '=',    nome: '= Igual', _formatar: [ 'id' ] }
            ]

            break
        }
        
        // RETORNA O VALOR MONTADO
        callback(vetor)
      },
      dfRecebidosOnBuscarOptionsFiltroV: function (callback, valor) {
        // INICIA O VETOR PARA OS CAMPOS
        var vetor = { disabled: false }

        // INICIA A FUNÇÃO PARA FINALIZAR
        var finalizar = null

        // VERIFICA OS OPTIONS QUE DEVE COLOCAR
        switch (valor.f) {
          case 'nome':
          case 'numero':
            vetor = Object.assign(vetor, {
              tipo: 'input',
              value: ''
            })
            break

          case 'cnpj':
            vetor = Object.assign(vetor, {
              tipo: 'input',
              mask: valor.f === 'cpf' ? 'cpf' : 'cnpj',
              value: ''
            })
            break

          case 'operacao':
            vetor = Object.assign(vetor, {
              tipo: 'select',
              keyValue: 'id',
              keyMostra: [ 'id', ' - ', 'nome' ],
              options: [
                { id: '0', nome: 'Entrada' },
                { id: '1', nome: 'Saída' }
              ],
              value: ''
            })
            break

          case 'status':
            vetor = Object.assign(vetor, {
              tipo: 'select',
              keyValue: 'id',
              keyMostra: [ 'nome' ],
              options: [
                { id: '0', nome: 'Sem ciência da operação' },
                { id: '1', nome: 'Com ciência da operação' },
                { id: '2', nome: 'Cancelada' }
              ],
              value: ''
            })
            break
        }
        
        // RETORNA O VALOR MONTADO
        if (finalizar === null && Object.keys(vetor).length >= 2) {
          callback(vetor)
        }
      },
      dfRecebidosSincronizarNotas: function () {
        if (confirm('O Rotina Fácil consulta a Sefaz automaticamente todos os dias nos seguintes horários: 07:00, 12:00 e 16:00.\n\nEvite fazer muitas consultas a Sefaz para que seu CNPJ não seja bloqueado.')) {
          // SETA O STATUS DO CAMPO
          this.campos.sincronizar.status = 'carregando'

          // SETA A FUNÇÃO PARA FINALIZAÇÃO DO PROCESSO
          const finalizacao = () => {
            // SETA OS VALORES RECEBIDOS
            this.campos.sincronizar.status = ''

            // CHAMA A FUNÇÃO PARA ATUALIZAR A TABELA
            this.dfRecebidosBuscarLinhas()

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }

          // SOLICITA A API A BUSCA DOS DADOS
          this.$store.state.comunicaAPI('/df/distribuicao/recebido', 'PUT', null, (retorno) => {
            if ([ '', null, undefined ].indexOf(retorno.lot) !== -1) {
              // APRESENTA A MENSAGEM DE SUCESSO
              this.$store.state.TRATAR_RET_LOT_API(retorno)

              // CHAMA A FUNÇÃO PARA FINALIZAR O PROCESSO
              this.dfRecebidosFecharFormulario(true, [ '', null, undefined ].indexOf(retorno.ref) === -1 && [ '', null, undefined ].indexOf(retorno.ref.id) === -1 ? retorno.ref.id : this.cpntId)
            } else {
              // PEGA O VALOR RECEBIDO
              retorno = retorno.lot[0]
  
              // VERIFICA SE DEU ERRO E RETORNA OS VALORES ORIGINAL DO CAMPO
              if (retorno.code !== '200') {
                this.dfRecebidosTratarValidacao(retorno.message, retorno.code, finalizacao)
              } else {
                // APRESENTA A MENSAGEM DE SUCESSO
                this.$store.state.TRATAR_RET_LOT_API(retorno)
                
                // CHAMA A FUNÇÃO PARA FINALIZAR O PROCESSO
                this.dfRecebidosFecharFormulario(true, [ '', null, undefined ].indexOf(retorno.ref) === -1 && [ '', null, undefined ].indexOf(retorno.ref.id) === -1 ? retorno.ref.id : this.cpntId)
              }
            }
          }, (apiError) => {
            // SETA O ERRO RECEBIDO
            this.dfRecebidosSetarStatusGeral(apiError)

            // FINALIZA O CARREGAMENTO
            finalizacao()
          }, (apiValid, apiStatus) => { this.dfRecebidosTratarValidacao(apiValid, apiStatus, finalizacao) })
        }
      },
      dfRecebidosTratarValidacao: function (apiValid, apiStatus = 400, callback = null) {
        // IMPORTA A FUNÇÃO QUE SERÁ UTILIZADA
        const FUN_TRATAR_VALIDACAO_API = require('@/assets/js/Funcoes-Gerais.js').FUN_TRATAR_VALIDACAO_API

        // FAZ A VERIFICAÇÃO E MONTAGEM DO FORMULARIO
        FUN_TRATAR_VALIDACAO_API(apiValid, apiStatus, this.campos, this).then(() => { callback() })
      },
      dfRecebidosFormatarNumeroCompra: function (valor) {
        // CONVERTE EM NUMERO O VALOR RECEBIDO
        valor = valor.toString()

        // RETORNA O VALOR FORMATADO
        return ((valor.length <= 4 ? ('0000' + valor).slice(-4) : valor))
      },
      dfRecebidosAbrirDocumento: function (id, acao = 'abrir') {
        this.$store.commit('SET_APP_PRINT_DOC_DOCS', { id: id, tipo: acao, acao: acao, buffer: '', origem: 'dist' })
      },
      dfRecebidosGerarCompra: function (id) {
        // SETA O VETOR
        var params = { ids: [] }

        // SETA OS IDS RECEBIDOS
        params.ids = [ id ]

        // FAZ O B64 DA VARIAVEL
        params.ids = window.btoa(JSON.stringify(params.ids))

        // MANDA ABRIR A PAGINA DE IMPORTAR XML
        this.$store.state.OPEN_PAGE_CS(this.$router.resolve({ name: 'config_importar_xml_df_recebido', params: params }).href, '_self', {}, false)
      },
      dfRecebidosAbrirCompra: function (id) {
        this.$store.state.OPEN_PAGE_CS(this.$router.resolve({ name: 'compra_numero', params: { id: id } }).href, '_blank', {}, false)
      },
      dfRecebidosDialogCiencia: function (linha) {
        // SETA O VALOR RECEBIDO
        this.dialog = linha

        // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
        this.time = new Date().getTime()
      }
    }
  }
</script>
